var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 11.3333V0.666667C0 0.298477 0.298477 0 0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667V11.3333C1.33333 11.5101 1.40362 11.6797 1.52865 11.8047C1.65367 11.9297 1.82319 12 2 12H12.6667C13.0349 12 13.3333 12.2985 13.3333 12.6667C13.3333 13.0349 13.0349 13.3333 12.6667 13.3333H2C1.46957 13.3333 0.96101 13.1225 0.585937 12.7474C0.210865 12.3723 0 11.8638 0 11.3333ZM10.862 4.19531C11.1223 3.93496 11.5443 3.93496 11.8047 4.19531C12.065 4.45566 12.065 4.87767 11.8047 5.13802L8.47135 8.47135C8.211 8.7317 7.78899 8.7317 7.52865 8.47135L5.33333 6.27604L3.80469 7.80469C3.54434 8.06504 3.12233 8.06504 2.86198 7.80469C2.60163 7.54434 2.60163 7.12233 2.86198 6.86198L4.86198 4.86198L4.91276 4.81641C5.17461 4.60284 5.56061 4.6179 5.80469 4.86198L8 7.05729L10.862 4.19531Z",
          fill: _vm.fill
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }